var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73333 20C6.21787 20 5.8 19.5821 5.8 19.0667V11.5982C5.8 11.1546 5.49996 10.7767 5.10742 10.57C4.61158 10.309 4.1776 9.93567 3.80547 9.45C3.26911 8.75 3.00062 7.93333 3 7V0.933333C3 0.417867 3.41787 0 3.93333 0C4.4488 0 4.86667 0.417867 4.86667 0.933333V6.53333C4.86667 6.79107 5.0756 7 5.33333 7C5.59107 7 5.8 6.79107 5.8 6.53333V0.933333C5.8 0.417867 6.21787 0 6.73333 0C7.2488 0 7.66667 0.417867 7.66667 0.933333V6.53333C7.66667 6.79107 7.8756 7 8.13333 7C8.39107 7 8.6 6.79107 8.6 6.53333V0.933334C8.6 0.417868 9.01787 0 9.53333 0C10.0488 0 10.4667 0.417868 10.4667 0.933334V7C10.4667 7.93333 10.1985 8.75 9.66213 9.45C9.28994 9.93575 8.85572 10.3091 8.35948 10.5702C7.9668 10.7767 7.66667 11.1547 7.66667 11.5984V19.0667C7.66667 19.5821 7.2488 20 6.73333 20ZM16.0667 20C15.5512 20 15.1333 19.5821 15.1333 19.0667V13C15.1333 12.4477 14.6856 12 14.1333 12H13.3333C12.781 12 12.3333 11.5523 12.3333 11V5C12.3333 3.61667 12.7885 2.43767 13.6988 1.463C14.366 0.748605 15.1354 0.295844 16.0068 0.104716C16.5465 -0.0136406 17 0.44803 17 1.00052V19.0667C17 19.5821 16.5821 20 16.0667 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodChallenge);
export default __webpack_public_path__ + "static/media/food-challenge.ee997fe83dc6a1f72ef1f85c58b713ee.svg";
export { ForwardRef as ReactComponent };